import React from 'react';
import { useTranslation } from 'react-i18next';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { Box } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import { DateTime } from 'luxon';
import GradeBookFormatSwitcher from 'modules/GradeBook/components/FormatSwitcher';
import GradeBookDatePicker from 'modules/GradeBook/components/GradeBookDatePicker';
import WeekDaySwitcher from 'modules/GradeBook/components/WeekDaySwitcher';

import { IClientGradeBooksModel } from '@common/models/ClientGradeBook/ClientGradeBooks';

interface PropsType {
	format: 'day' | 'week';
	dateTime: DateTime<boolean>;
	setDateTime: (newDateTime: DateTime) => void;
	gradeBooks: IClientGradeBooksModel;
	onSetFormat: (format: 'day' | 'week') => void;
}

function GradeBookHeader({ format, dateTime, setDateTime, gradeBooks, onSetFormat }: PropsType) {
	const { t } = useTranslation();

	const isTodaySelected = dateTime.hasSame(DateTime.now().setZone(dateTime.zoneName), 'day');

	const handleSetToday = () => {
		setDateTime(DateTime.now().setZone(dateTime.zoneName).startOf('day'));
	};

	const showTodayButton = format === 'day' && !isTodaySelected;

	return (
		<Box
			sx={{
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				borderRadius: '0 0 16px 16px',
				border: '1px solid #C3DCFF',
				borderTop: 'none',
				padding: '8px 8px 16px 8px',
			}}
		>
			<GradeBookDatePicker
				value={dateTime}
				onChange={setDateTime}
				format={format}
				daysNumber={gradeBooks?.days?.length}
			>
				<GradeBookFormatSwitcher format={format} onSetFormat={onSetFormat} />
			</GradeBookDatePicker>

			<WeekDaySwitcher format={format} dateTime={dateTime} setDateTime={setDateTime} />
			{showTodayButton && (
				<Box
					onClick={handleSetToday}
					sx={{
						cursor: 'pointer',
						position: 'absolute',
						right: '0',
						bottom: '-14px',
						display: 'flex',
						gap: '4px',
						alignItems: 'center',
						color: '#292929',
						borderRadius: '12px 0 0 12px',
						background: '#71ABFF',
						padding: '0 8px',
						boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
					}}
				>
					<ArrowLeftIcon fontSize="small" />
					<MediaTypography>{t('gradeBook.today')}</MediaTypography>
				</Box>
			)}
		</Box>
	);
}

export default GradeBookHeader;
